document.addEventListener("DOMContentLoaded", function () {
  const splideEl = document.querySelector(".lighting-splide-container");
  if (!splideEl) return;

  splideEl.splide.on('ready', () => {
    console.log("ready")
    const initialIndex = splideEl.splide.index || 0; 
    setActive(initialIndex);
  });

  const rightItems = document.querySelectorAll(".lighting-collection-categories li");

  function setActive(index) {
    rightItems.forEach((item) => item.classList.remove("active"));
    if (rightItems[index]) {
      rightItems[index].classList.add("active");
    }
  }

  splideEl.splide.on("move", (newIndex) => {
    setActive(newIndex);
  });

});
